/** Map from ModelIndex to the axis option of the column */

/** Map from ModelIndex to a color or an array of colors
 * If given an array, then the bar will be a gradient
 * The colors should be given left to right (e.g. it should be like ['yellow', 'green'] for positive color and ['red', 'yellow'] for negative color)
 */

/** Map from ModelIndex to the value placement option of the column */

/** Map from ModelIndex to the opacity of the column */

/** Map from ModelIndex to the direction of the column */

/** Map from ModelIndex to the text alignment of the column */

/** Map from column to the columns its markers are from */

/** Map from column to whether the bar has a gradient */

// Map from ModelIndex to the minimum number in the column

// Map from ModelIndex to the maximum number in the column

export function isDataBarGridModel(model) {
  return (model === null || model === void 0 ? void 0 : model.dataBarOptionsForCell) !== undefined;
}
//# sourceMappingURL=DataBarGridModel.js.map